<div class="dvb-report-group-admin-kind-tages-infos">
    <h2 data-translate="REPORT.GROUP_ADMIN_KIND_TAGESINFOS.TITLE"></h2>

    <form name="vm.groupAdminKindTagesinfosReportForm" novalidate>

        <dvb-search-get-single-entity as-col="true"
                                      entity-to-search="KIND"
                                      ng-model="vm.kind"
                                      placeholder-key="COMMON.KIND.AUSWAEHLEN"
                                      required>
        </dvb-search-get-single-entity>

        <div class="row form-row">
            <div class="col-xs-12">
                <dvb-datepicker-text-field ng-change="vm.updateState()"
                                           ng-model="vm.gueltigAb"
                                           ng-attr-placeholder="{{'COMMON.GUELTIG_AB_DATUM' | translate:{datum: (vm.gueltigAb || vm.defaultGueltigAb | amDateFormat: 'DD.MM.YYYY')} }}">
                </dvb-datepicker-text-field>
                <dvb-datepicker-text-field ng-change="vm.updateState()"
                                           ng-model="vm.gueltigBis"
                                           ng-attr-placeholder="{{'COMMON.GUELTIG_BIS_DATUM' | translate:{datum: (vm.gueltigBis || vm.defaultGueltigBis | amDateFormat: 'DD.MM.YYYY')} }}">
                </dvb-datepicker-text-field>
            </div>
        </div>
        <dvb-report-download on-submit="vm.onSubmit(groupAdminKindTagesinfosReportForm)"></dvb-report-download>
    </form>
</div>
